__turbopack_context__.v({
  "button": "ky_pDG_button",
});
